export const loginReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        isAuthenticated: true,
      };
    case "LOGOUT":
      return {
        isAuthenticated: false,
      };
    default:
      throw new Error();
  }
};
export const setAdminReducer = (state, action) => {
  switch (action.type) {
    case "ISADMIN":
      return {
        admin: true,
      };
    case "ISUSER":
      return {
        admin: false,
      };
    default:
      throw new Error();
  }
};
